import axiosClient from "../axiosInstance";

export const getBatteryGroups = async (): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(`/battery-groups`);

  return response.data;
};

export const getBatteryGroup = async (id: number): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(`/battery-groups/${id}`);

  return response.data;
};

export const createBatteryGroup = async (postData: any): Promise<any> => {
  const client = axiosClient();

  const response = await client.post(`/battery-groups`, postData);

  return response.data;
};

export const updateBatteryGroup = async (
  id: number,
  postData: any,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.put(`/battery-groups/${id}`, postData);

  return response.data;
};

export const deleteBatteryGroup = async (id: number): Promise<any> => {
  const client = axiosClient();

  const response = await client.delete(`/battery-groups/${id}`);

  return response.data;
};

export const updateBatteryGroupBatteries = async (
  id: number,
  postData: { batteryIds: number[] },
): Promise<any> => {
  const client = axiosClient();

  const response = await client.put(
    `/battery-groups/${id}/batteries`,
    postData,
  );

  return response.data;
};
